import React, { useState } from "react";
import "../../assets/css/style.css";
import "../../assets/css/login.css"


import LoginForm from "../../components/login/loginForm"
import AccountCreated from "../../components/login/accountCreated";

const Login = () => {

    return (
        <div className="main">
            <LoginForm />
        </div>

    );
};

export default Login;